import { Navigate } from "react-router-dom";
import { HeaderNetworkPortal } from "../Components/NetworkPortal/CommonComponent/HeaderNetworkPortal";
import { LeftSideBarNetworkPortal } from "../Components/NetworkPortal/CommonComponent/LeftSideBarNetworkPortal";
import ROUTES from "../Utils/routesConstants";
import { getRole, getToken } from "../Utils/types";

const PrivateNetworkRoute = ({ Component }) => {
  const auth = getToken();
  return auth && getRole() === "NetworkAdmin" ? (
    <div
      className={`${
        window.location.pathname.includes(ROUTES?.APPOINMENT_MANAGEMENT)
          ? ""
          : "__custom_scroller__properties"
      }`}
    >
      <div className="___parent_container">
        <HeaderNetworkPortal />
        <div className="main-section">
          <LeftSideBarNetworkPortal />
          <Component />
        </div>
      </div>
    </div>
  ) : (
    <Navigate to="/" />
  );
};

export default PrivateNetworkRoute;
